import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "antd";
import { Link } from "react-router-dom";
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { FileExcelFilled } from "@ant-design/icons";
import { Excel } from "antd-table-saveas-excel";
import { VillageTransportRequestDto } from "@gtpl/shared-models/masters";
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { VillageTransportCostService } from "@gtpl/shared-services/masters";

export const VillageTransportCost = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [form] = Form.useForm();
  const services = new  VillageTransportCostService()

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);

  const importExcel = (file) => {
    const data = new Uint8Array(file);
    const wb = XLSX.read(data, { type: 'array', cellDates: true });
    let sheet = [];
    for (const Sheet in wb.Sheets) {
      if (Sheet) {
        if (wb.Sheets.hasOwnProperty(Sheet)) {
          sheet.push(XLSX.utils.sheet_to_json(wb.Sheets[Sheet], { raw: true, header: 1 }));
        }
      }
    }
    return sheet;
  };

  const excelData = [
    { title: 'S No', dataIndex: 'sNo', render: (text, object, index) => index + 1, width: 60 },
    { title: 'Village Name', dataIndex: 'villageName', width: 500, render: (text, record) => record.villageName ? record.villageName : '-' },
    { title: 'Transport cost', dataIndex: 'transportCost', width: 100, render: (text, record) => record.transportCost ? record.transportCost : '-' }
  ];

  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet('village-transport-cost Sample')
      .addColumns(excelData)
      .saveAs('village-transport-cost Sample.xlsx');
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'text/csv') {
      setSelectedFile(file);
      Papa.parse(file, {
        header: true,
        complete: function (result) {
          const columnArray = [];
          const valueArray = [];
          result.data.forEach((d) => {
            columnArray.push(Object.keys(d));
            valueArray.push(Object.values(d));
          });
          setData(result.data);
          setColumns(columnArray[0]);
          setValues(valueArray);
          console.log(result.data); // Log the parsed CSV data
        },
        skipEmptyLines: true
      });
    } else if (file && file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async () => {
        const csvData = importExcel(reader.result);
        const filteredData = csvData.filter(innerData => innerData.some(row => row.length > 0));
        const output = filteredData.map(innerData => {
          const header = innerData[0];
          return innerData.slice(1).map(row => {
            if (row.every(value => value === '')) {
              return null;
            }
            return row.reduce((acc, value, index) => {
              acc[header[index]] = value;
              return acc;
            }, {});
          }).filter(row => row !== null);
        });
        setData(output[0]);
        console.log(output[0]); // Log the parsed Excel data
      }
    } else {
      alert('Please select a valid .csv or .xlsx file.');
      setSelectedFile(null);
    }
  };
  let createdUser="";

    createdUser= localStorage.getItem("createdUser");
    
  const handleUpload = async() => {
    try{
        form.validateFields().then(async () => {
          const req = new VillageTransportRequestDto(data,createdUser)
            const res = await services.saveVillageTransportInfo(req).then(res => {
                setLoading(true);
                if(res.status){
                  AlertMessages.getSuccessMessage(res.internalMessage)
                  setLoading(false)
                    // history.push("/")
  
                } else{
                  setLoading(false)
                    AlertMessages.getErrorMessage(res.internalMessage)
                }
            })
        })
    } catch (error) {
        AlertMessages.getErrorMessage(error.message);
      }
  }
  

  return (
    <Card title='Village Transportion Costs' extra={<Link to='/village-transport-cost-grid'><Button type='primary'>View</Button></Link>}>
      <Form>
        <Row gutter={24}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item label="">
              <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={handleFileChange} />
              <label style={{ color: 'blue', whiteSpace: 'nowrap' }}>Only csv & excel files are allowed</label>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Button type="primary" onClick={handleUpload} loading={loading} disabled={!selectedFile}>Upload</Button>
          </Col>
          <Button type="default" style={{ color: "green" }} onClick={exportExcel} icon={<FileExcelFilled />}>
            Sample Format for Excel Upload
          </Button>
        </Row>
      </Form>
    </Card>
  );
};

export default VillageTransportCost;
